module.exports = __webpack_public_path__ + "static/media/logo_menu_interattivo.35b1971a.svg";